import { defineNuxtPlugin } from '#imports'
import { bffApi } from '@shared/service/bff'
import type { Middleware } from 'openapi-fetch'

const V1_AUTH_ROUTES_REGEX =
  /^\/api\/v1\/(user|profile|onramp|authorization\/logout|mobile)/
const V2_AUTH_ROUTES_REGEX = /^\/api\/v2\/(?:entry-code\/verify)(?:\/|$)/

export default defineNuxtPlugin({
  name: 'auth',
  dependsOn: ['store'],
  setup() {
    const authStore = useAuthStore()

    const authMiddleware: Middleware = {
      onRequest({ request, schemaPath }) {
        if (
          !V1_AUTH_ROUTES_REGEX.test(schemaPath) &&
          !V2_AUTH_ROUTES_REGEX.test(schemaPath)
        ) {
          return request
        }

        if (authStore.accessToken && !request.headers.has('Authorization')) {
          request.headers.set(
            'Authorization',
            `Bearer ${authStore.accessToken}`
          )
        }

        return request
      },

      onResponse({ response }) {
        const newAccessToken = response.headers.get('X-New-Access-Token')

        if (!newAccessToken) {
          return response
        }

        const refreshExpiresHeader = response.headers.get(
          'X-Refresh-Token-Expires-At'
        )
        const refreshExpiresAtMs = refreshExpiresHeader
          ? Number(refreshExpiresHeader)
          : null

        authStore.setSessionTokens({
          accessToken: newAccessToken,
          refreshTokenExpiresAt: Number.isFinite(refreshExpiresAtMs)
            ? refreshExpiresAtMs
            : null
        })

        return response
      }
    }

    bffApi.use(authMiddleware)

    const sharedWalletStore = useSharedWalletStore()

    if (sharedWalletStore.isUserConnected) {
      authStore.refreshSession().catch(() => {})
    }
  }
})
